export const contentSP = `
    connect-src 'self' 
    ${process.env.REACT_APP_CONNECT_HOST} 
    data: ;

    default-src 'self' 
    data: ;

    img-src 'self' 
    https: data:
    data: ;


    style-src 'self' 
    https://fonts.googleapis.com/ 
    https://fonts.gstatic.com/ ;

    font-src 'self' 
    https://fonts.googleapis.com/ 
    https://fonts.gstatic.com/ ;
`;
